import React from "react";
import { HOME, PENGUIN_PERKS_PAGE } from "../../../constants/routes";
import { useHistory } from "react-router-dom";


const BookNow = () => {

  const history = useHistory()

    const goToBookPage = () => {
        history.push(HOME)
      }
    return (
        <ScheduleButton action={goToBookPage} title="Book Now" />
    )
}


const PenguinPerksButton = () => {

    const history = useHistory()
  
      const goToPenguinPerks = () => {
          history.push(PENGUIN_PERKS_PAGE)
        }
      return (
          <ScheduleButton action={goToPenguinPerks} title="Save Money With Penguin Perks" />
      )
  }

const ScheduleButton = (props) => {

    return (
        <button className="schedule-book-now" onClick={props.action}>{props.title}</button>
    )
}

export {
    ScheduleButton, BookNow, PenguinPerksButton
}